import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import router, { ROUTER_LOGIN } from '../router';

axios.defaults.baseURL = 'https://xiaochengxu.ivideocity.com/api';
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
};

// request 拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// respone 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        Message.warning('系统正在快速开发中。。。');
        return Promise.reject(error);
    }
);

export function post(url, params = {}, options = {}, shouldQs = true) {
    const token = localStorage.getItem('token');
    let data = { ...params };
    if (token) {
        data = { ...data, token };
    }
    return new Promise((resolve, reject) => {
        axios
            .post(url, shouldQs ? qs.stringify(data) : data, options)
            .then(res => res.data)
            .then(json => {
                if (json.code === 0) {
                    resolve(json.data);
                } else if (json.code === 1003) {
                    router.replace(ROUTER_LOGIN);
                } else {
                    Message.warning(json.msg);
                    reject(json.msg);
                }
            });
    });
}

export function postFile(url, params) {
    const token = localStorage.getItem('token');
    params.append('token', token);
    const options = { headers: { 'Content-Type': 'multipart/form-data' } };
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, options)
            .then(res => res.data)
            .then(json => {
                if (json.code === 0) {
                    resolve(json.data);
                } else if (json.code === 1003) {
                    router.replace(ROUTER_LOGIN);
                } else {
                    Message.warning(json.msg);
                    reject(json.msg);
                }
            });
    });
}

export function get(url, params = {}) {
    const token = localStorage.getItem('token');
    let data = { ...params };
    if (token) {
        data = { ...data, token };
    }
    return new Promise((resolve, reject) => {
        axios(url, {
            params: data,
        })
            .then(res => res.data)
            .then(json => {
                if (json.code === 0) {
                    resolve(json.data);
                } else {
                    Message.warning(json.msg);
                    reject(json.msg);
                }
            });
    });
}
